import axios from 'axios'
import notifService from '../../services/notifService'

export const getBrand = async (context, pagination) => {
  let res = await axios
    .get('/cms/brand', {
      params: pagination
    })
    .then(response => {
      context.commit('getBrand', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const listBrand = async (context, pagination) => {
  await axios
    .get('/cms/brand', {
      params: pagination
    })
    .then(response => {
      context.commit('listBrand', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const addBrand = async (_context, val) => {
  return await axios
    .post('/cms/brand/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const editBrand = async (_context, val) => {
  return await axios
    .put('/cms/brand/edit/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const deleteBrand = async (_context, val) => {
  return await axios
    .delete('/cms/brand/delete/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const brandForm = (context, val) => {
  context.commit('brandForm', val)
}

export const getGroupPrincipal = async (context, pagination) => {
  return await axios
    .get('/cms/group-principals', {
      params: pagination
    })
    .then(response => {
      context.commit('getGroupPrincipal', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const addGroupPrincipal = async (_context, val) => {
  return await axios
    .post('/cms/group-principals/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const editGroupPrincipal = async (_context, val) => {
  return await axios
    .put('/cms/group-principals/edit/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const deleteGroupPrincipal = async (_context, val) => {
  return await axios
    .delete('/cms/group-principals/delete/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const groupForm = (context, val) => {
  if (val && val.id) context.commit('groupForm', val)
  else
    context.commit('groupForm', {
      name: '',
      principals: null
    })
}
